import { render, staticRenderFns } from "./DesktopMonthPicker.vue?vue&type=template&id=37906904&"
import script from "./DesktopMonthPicker.vue?vue&type=script&lang=ts&"
export * from "./DesktopMonthPicker.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopMonthPicker.vue?vue&type=style&index=0&id=37906904&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports